import { useEffect, useState } from "react";
import { toast } from "sonner";
import { errText } from "@/lib/api";
import { Panel, Btn, inputCls } from "./ui";

const KEYS = ["quip_plaintext", "quip_key", "quip_clue", "quip_solved_text"];

// 333secret.com cryptoquip settings. Changing the line or key resets every player's saved progress.
export function QuipControls({ api, s, setS, Field }) {
  const [preview, setPreview] = useState(null);
  const refresh = () => api.get("/cryptoquip").then((r) => setPreview(r.data)).catch(() => setPreview(null));
  useEffect(() => { refresh(); }, []);  // eslint-disable-line react-hooks/exhaustive-deps
  const set = (k) => (e) => setS({ ...s, [k]: e.target.value });
  const save = async () => {
    try { const r = await api.put("/settings", Object.fromEntries(KEYS.map((k) => [k, s[k]]))); setS(r.data); toast.success("Saved"); refresh(); }
    catch (e) { toast.error(errText(e)); }
  };
  const regen = async () => {
    if (!window.confirm("Make a new random key? Everyone's saved progress resets.")) return;
    try {
      const r = await api.post("/cryptoquip/regenerate");
      setPreview(r.data);
      const fresh = await api.get("/settings");
      setS(fresh.data);
      toast.success("New key");
    } catch (e) { toast.error(errText(e)); }
  };
  return (
    <Panel title="Cryptoquip (333secret.com)" actions={<div className="flex gap-2"><Btn variant="ghost" data-testid="controls-quip-regenerate" onClick={regen}>New random key</Btn><Btn data-testid="controls-save-quip" onClick={save}>Save</Btn></div>}>
      <div className="space-y-3">
        <Field label="Plaintext (letters are encrypted, spaces kept; never sent to players' browsers)"><input data-testid="controls-quip-plaintext" className={`${inputCls} mono`} value={s.quip_plaintext} onChange={set("quip_plaintext")} /></Field>
        <Field label="Key: 26 letters, position 1 = what A becomes (each letter once, none maps to itself)"><input data-testid="controls-quip-key" className={`${inputCls} mono tracking-widest`} value={s.quip_key} onChange={set("quip_key")} /></Field>
        <Field label="Starter clue: cipher letter to reveal (blank = auto-pick a letter that appears 2+ times)"><input data-testid="controls-quip-clue" maxLength={1} className={`${inputCls} mono !w-20`} value={s.quip_clue} onChange={set("quip_clue")} /></Field>
        <Field label="M's line after solving"><input data-testid="controls-quip-solved-text" className={inputCls} value={s.quip_solved_text} onChange={set("quip_solved_text")} /></Field>
        {preview && (
          <div data-testid="controls-quip-preview" className="rounded border border-[#243144] bg-[#0b1220] p-3 mono text-xs text-slate-300">
            <div className="tracking-[0.2em] text-amber-300">{preview.cipher}</div>
            <div className="mt-1 text-slate-400">CLUE: {preview.clue.cipher} = {preview.clue.plain} · bonus order after wipes: {preview.bonus.map((b) => `${b.cipher}=${b.plain}`).join(", ")}</div>
          </div>
        )}
      </div>
    </Panel>
  );
}
